// extracted by mini-css-extract-plugin
export default {"root":"Kgm7Jn","cards-container":"hqs26T","cardsContainer":"hqs26T","price-no-padding":"nCcqVq","priceNoPadding":"nCcqVq","feature-icon":"UNXHSU","featureIcon":"UNXHSU"};